import { render, staticRenderFns } from "./add-addtional-manager.vue?vue&type=template&id=07e922b4&scoped=true"
import script from "./add-addtional-manager.vue?vue&type=script&lang=ts"
export * from "./add-addtional-manager.vue?vue&type=script&lang=ts"
import style0 from "./add-addtional-manager.vue?vue&type=style&index=0&id=07e922b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e922b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e922b4')) {
      api.createRecord('07e922b4', component.options)
    } else {
      api.reload('07e922b4', component.options)
    }
    module.hot.accept("./add-addtional-manager.vue?vue&type=template&id=07e922b4&scoped=true", function () {
      api.rerender('07e922b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paymentV2/dialog/add-addtional-manager.vue"
export default component.exports